import { AxiosInstance, AxiosResponse } from "axios";

let promise: Promise<AxiosResponse> | null = null;

export async function getPublicToken(client: AxiosInstance) {
  if (!promise) {
    promise = client.post<{ token: string }>("/authenticate/json/v2", undefined, {
      headers: {
        remember: true
      },
      auth: {
        username: process.env.REACT_APP_PUBLIC_EMAIL!,
        password: process.env.REACT_APP_PUBLIC_PASSWORD!,
      },
    });
  }

  const authResponse = await promise;

  return authResponse.data.token;
}

export async function getPublicTokenForHybrid(hybrid: AxiosInstance) {
  const authResponse = await hybrid.post<{ token: string }>("/authenticate/json/v2", undefined, {
    headers: {
      remember: true
    },
    auth: {
      username: process.env.REACT_APP_PUBLIC_EMAIL!,
      password: process.env.REACT_APP_PUBLIC_PASSWORD!,
    },
  });

  return authResponse.data.token;
}